import { render, staticRenderFns } from "./UserCommonList.vue?vue&type=template&id=38bc1fe5&scoped=true&"
import script from "./UserCommonList.vue?vue&type=script&lang=js&"
export * from "./UserCommonList.vue?vue&type=script&lang=js&"
import style0 from "./UserCommonList.vue?vue&type=style&index=0&id=38bc1fe5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc1fe5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
